"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = exports.shadow = exports.resetComponent = exports.fontSize = exports.ellipsis = exports.clearFix = exports.border = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var fontSize = exports.fontSize = function fontSize(css) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'medium';
  var postfix = '';
  if (size === 'large') {
    postfix = 'Lg';
  } else if (size === 'small') {
    postfix = 'Sm';
  }
  return css(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n    line-height: 1.5em;\n  "])), function (props) {
    return props.theme.font['size' + postfix];
  });
};
var border = exports.border = function border(css) {
  return css(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  border: ", ";\n"])), function (props) {
    return "".concat(props.theme.border.width, " ").concat(props.theme.border.style, " ").concat(props.theme.border.colorBase);
  });
};
var resetComponent = exports.resetComponent = function resetComponent(css) {
  return css(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-variant: ", ";\n  line-height: ", ";\n  list-style: none;\n  font-feature-settings: ", ";\n"])), function (props) {
    return props.theme.text.color;
  }, function (props) {
    return props.theme.font.family;
  }, function (props) {
    return props.theme.font.size;
  }, function (props) {
    return props.theme.font['tabular-nums'];
  }, function (props) {
    return props.theme.font.lineHeight;
  }, function (props) {
    return props.theme.font.featureSettings;
  });
};
var ellipsis = exports.ellipsis = function ellipsis(css, maxWidth) {
  return css(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  max-width: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])), maxWidth);
};
var clearFix = exports.clearFix = function clearFix(css) {
  return css(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  &:before,\n  &:after {\n    content: ' ';\n    display: table;\n  }\n  &:after {\n    clear: both;\n  }\n"])));
};
var truncate = exports.truncate = function truncate(css, width) {
  return css(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  width: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n"])), width);
};
var shadow = exports.shadow = function shadow(css) {
  return css(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  box-shadow: 5px 0px 5px 0px ", ";\n"])), function (props) {
    return props.theme.shadow.color;
  });
};